module.exports = __webpack_public_path__ + "img/图片3.f38fc7d1.png";